Object.defineProperty(exports, "__esModule", {
  value: true
});

// Customizable Area Start
exports.httpGetMethod = "GET";
exports.httpPostMethod = "POST";
exports.httpPutMethod = "PUT";
exports.httpDeleteMethod = "DELETE";
exports.httpPatchMethod = "PATCH";
exports.searchApiContentType = "application/json";
exports.getSearchApiEndPoint = "search/users";
exports.errorTitle = "Error";
exports.TOKEN = "token";
exports.PROFILE = "profile";
exports.getCustomizableProfileEndPoint = "bx_block_profile/profile/current_user_profile";
exports.updateCustomizableProfileEndPoint = "bx_block_profile/profile/update_user_profile";
exports.getCustomizableProfileFieldsEndPoint =
  "bx_block_profile/profile/custom_user_profile_fields";
  exports.imgUpload="../assets/image__upload.png";
  exports.monthName = [
    { value: 'January', key: 'Jan' },
    { value: 'February', key: 'Feb' },
    { value: 'March', key: 'Mar' },
    { value: 'April', key: 'Apr' },
    { value: 'May', key: 'May' },
    { value: 'June', key: 'Jun' },
    { value: 'July', key: 'Jul' },
    { value: 'August', key: 'Aug' },
    { value: 'September', key: 'Sep' },
    { value: 'October', key: 'Oct' },
    { value: 'November', key: 'Nov' },
    { value: 'December', key: 'Dec' },
  ];
  exports.instituteName = [
    { value: 'St. Xaviers College', key: 'clg1' },
    { value: 'Ahmedabad Management Association', key: 'clg2' },
    { value: 'Nirma University of Science and Technology', key: 'clg3' },
  ];
  exports.qualification = [
    { value: 'Diploma in acting', key: 'Jan' },
    { value: 'Diploma in Painting', key: 'Feb' },
    { value: 'Diploma in Computer', key: 'Mar' },
  ];
  exports.languages = [
    { value: "Arabic", key: 'Arabic' },
    { value: "Bengali", key: 'Bengali' },
    { value: "English", key: 'English' },
    { value: "French", key: 'French' },
    { value: "Hindi", key: 'Hindi' },
    { value: "Japanese", key: 'Japanese' },
    { value: "Russian", key: 'Russian' },
    { value: "Spanish", key: 'Spanish' },
    { value: "Telugu", key: 'Telugu' },
    { value: "Turkish", key: 'Turkish' }
  ];
  exports.gender = [
    { value: "Male", key: 'male' },
    { value: "Female", key: 'female' },
    { value: "Other", key: 'other' }
  ]
exports.location = [
  { value: "Canada", key: "North America" },
  { value: "Brazil", key: "South America" },
  { value: "Australia", key: "Oceania" }
]
exports.skillsData = [
  {
    category: "Acting",
    subCategories: ["Film", "Television", "Voice Acting"],
  },
  {
    category: "Music",
    subCategories: [
      "Instrumentalists", "Guitar", "Piano", "Violin", "Drums", "Bass", "Saxophone", "Flute", "Trumpet", "Other"
    ],
  },
];
exports.updateProfilePicture = "account_block/edit_profile_picture";
exports.updateCoverPicture = "account_block/edit_cover_photo";
exports.deleteProfilePicture = "account_block/delete_profile_image";
exports.deleteCoverPicture = "account_block/delete_cover_image";
exports.deletePortfolioMedia = "account_block/delete_profile_image";
exports.getUserProfileDetails = "account_block/accounts";
exports.editSocialLinks = "account_block/social_media_links";
exports.editProfileDetails = "account_block/edit_profile";
exports.editPortfolioLink = "account_block/portfolio_links";
exports.getCategoryListing = "bx_block_categories/category_lists";
exports.addCareerHighlights = "bx_block_profile/user_careers";
exports.getProfileDetails = "account_block/accounts";
exports.getLocationDetails = "account_block/india_states";
exports.getLanguageList = "bx_block_language/user_languages";
exports.editProfessionalSkill = "account_block/edit_profile_skill";
exports.deleteProfessionalSkill = "account_block/delete_sub_category";
exports.addEducationAndTraining = "bx_block_profile/user_educations";
exports.deletePortfolioEndPoint = "account_block/account_media";
// Customizable Area End
